import { graphql, PageProps } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { FC } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";

import { Layout } from "../shared/Layout";

const RICHTEXT_OPTIONS = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return <p style={{ marginBottom: 10 }}>{children}</p>;
    },
  },
};

export const query = graphql`
  query($id: String!) {
    contentfulBlog(contentful_id: { eq: $id }) {
      contentful_id
      body {
        raw
      }
      createdAt(formatString: "MM-DD-YYYY")
      updatedAt(formatString: "MM-DD-YYYY")
      slug
      title
      blogImage {
        gatsbyImageData
      }
      authorImage {
        gatsbyImageData
      }
      author
      preview {
        childMarkdownRemark {
          html
          excerpt
        }
      }
    }
  }
`;

interface Props {
  data: any;
  location: PageProps["location"];
}

const Coffee: FC<Props> = ({ location, data }) => {
  const {
    title,
    body,
    updatedAt,
    slug,
    author,
    preview,
    blogImage,
  } = data?.contentfulBlog;

  const json = JSON.parse(body.raw);

  return (
    <Layout
      seo={{
        description: preview.childMarkdownRemark.excerpt,
        title: `${title} | Psycho Betty Coffee`,
        keywords: [title, slug, author],
      }}
      location={location}
      backgroundColor="white"
    >
      <div className="relative py-8 sm:py-16 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
          <div className="text-xl max-w-prose mx-auto">
            <h1>
              <span className="block text-2xl text-center text-red-600 font-semibold tracking-wide uppercase">
                {author} <span>{" - "}</span>
                {updatedAt}
              </span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                {title}
              </span>
            </h1>
            <GatsbyImage
              image={blogImage.gatsbyImageData}
              className="w-full rounded-md mt-6"
              alt={title}
            />
            <div className="mt-6 prose prose-blue prose-lg text-black mx-auto font-inter font-extralight lg:text-left text-center">
              {documentToReactComponents(json, RICHTEXT_OPTIONS)}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Coffee;
